import React from 'react';
import {
  Box,
  IconButton,
} from '@mui/material';
import { observer } from 'mobx-react';
import { PopulatedCampaignUserDto } from '@coretava/api/ecommerce-service';
import Close from '@mui/icons-material/Close';
import { CashbackPopupsStore } from '@gamiphy/loyalty-station-desktop/store/cashbackPopups';
import { Campaign } from '../../../campaigns';

const BogoCampaignPopup: React.FC<{ campaignUser: PopulatedCampaignUserDto }> = ({ campaignUser }) => (
  <Box maxWidth={350}>
    <Box p="1.6rem" pb={0} display="flex" justifyContent="flex-end">
      <IconButton sx={{ ml: 'auto', p: 0 }} disableRipple onClick={() => CashbackPopupsStore.closeCashbackPopup()}>
        <Close fontSize="large" />
      </IconButton>
    </Box>
    <Campaign campaign={campaignUser.campaign} status={campaignUser.status} textAlign="center" />
  </Box>
);

export default observer(BogoCampaignPopup);
